/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { UtEditorModule } from '../common/ut-editor/ut-editor.module';
import { TopicFormPageComponent } from './topic-form-page.component';
import { EmojiHtmlPipe } from '../pipes/emoji-html.pipe';

// An NgModule rather than standalone because UtEditorModule registers the AngularJS service providers
// the editor needs.
@NgModule({
  imports: [CommonModule, UIRouterModule, UtEditorModule, EmojiHtmlPipe],
  declarations: [TopicFormPageComponent],
  exports: [TopicFormPageComponent],
})
class TopicFormPageModule {}

export { TopicFormPageModule };
